// Add your custom JS here.
const frontImage = $('.front-image .image-wrapper');
const backImage = $('.back-image .image-wrapper');

const frontImageContainer = $('.front-image');
const backImageContainer = $('.back-image');

const overlappingImages = $('.overlapping-images');

let frontImagePosition = 0;
let backImagePosition = 0;

let currentFrontImagePosition = 0;
let currentBackImagePosition = 0;

let currentFrontImageContainerPosition = 20;
let currentBackImageContainerPosition = -17.5;

let isSeeFrontAndBackImage = false;

const createScaleY = (x1, y1, x2, y2) => {
  const slope = (y2 - y1) / (x2 - x1);
  return (y3) => {
    if (slope === 0) {
      return null;
    }
    return ((y3 - y1) / slope) + x1;
  }
}

const getSlideImagePosition = (element) => {
  const imageWrapperBounding = element.get(0).getBoundingClientRect();
  const imageWrapperHeight = imageWrapperBounding.bottom - imageWrapperBounding.top;
  
  const scaleY = createScaleY(-10, imageWrapperHeight * -1, 10, window.innerHeight);
  const imagePosition = scaleY(imageWrapperBounding.top);
  return imagePosition;
};

const updateImagePosition = (element, position) => {
  if (typeof position === 'number') {
    element.css('transform', `translate(0px, ${position}%) scale(1.2)`);
  }
}

const updateImageWrapperPositionBaseOnScroll = () => {
  frontImagePosition = getSlideImagePosition(frontImage);
  backImagePosition = getSlideImagePosition(backImage);
}

const playFrontAndBackImageContainer = () => {
  currentFrontImageContainerPosition += (0 - currentFrontImageContainerPosition) * 0.05;
  
  if (currentFrontImageContainerPosition > 0.005) {
      frontImageContainer.css('transform', `translate(0, ${currentFrontImageContainerPosition}%)`); 
  }
  
  currentBackImageContainerPosition += (0 - currentBackImageContainerPosition) * 0.05;
  
  if (currentBackImageContainerPosition < -0.005) {
      backImageContainer.css('transform', `translate(0, ${currentBackImageContainerPosition}%)`);
  }
 
  requestAnimationFrame(playFrontAndBackImageContainer);
};

const playOverlappingImagesWhenSee = () => {
  const overlappingImagesBounding = overlappingImages.get(0).getBoundingClientRect();
  console.log('overlappingImagesBounding', overlappingImagesBounding.top)
  if (overlappingImagesBounding.top <= window.innerHeight - 80) {
    playFrontAndBackImageContainer();
    isSeeFrontAndBackImage = true;
  }
};

$(window).scroll(() => {
  requestAnimationFrame(() => {
    updateImageWrapperPositionBaseOnScroll();
    if (!isSeeFrontAndBackImage) {
      playOverlappingImagesWhenSee(); 
    }
  });
});

const loop = () => {
  currentFrontImagePosition += (frontImagePosition - currentFrontImagePosition) * 0.1;
  currentBackImagePosition += (backImagePosition - currentBackImagePosition) * 0.1;
  
  updateImagePosition(frontImage, currentFrontImagePosition);
  updateImagePosition(backImage, currentBackImagePosition * -1);
  requestAnimationFrame(loop) 
}

playOverlappingImagesWhenSee();

loop();

//redirection vers l'accordéon des prestation
function redirectAndOpenAccordion(url) {
  // Vérifier si l'URL contient un ancre (ex : #section01)
  if (url.includes("#")) {
    console.log("prouut");
    // Séparer l'URL de l'ancre
    const [pageUrl, anchor] = url.split("#");
    
    // Rediriger vers la page spécifique
    window.location.href = pageUrl;

    // Attendre que la page soit chargée
    window.onload = function () {
      // Trouver l'accordéon correspondant à l'ancre
      const accordion = document.querySelector("#accordionEntreprise");
      const targetAccordion = accordion.querySelector(`#${anchor}`);

      // Vérifier si l'accordéon existe et le faire défiler jusqu'à lui
      if (targetAccordion) {
        targetAccordion.scrollIntoView({ behavior: "smooth" });
        
        // Ouvrir la section de l'accordéon correspondant
        const accordionButton = targetAccordion.previousElementSibling;
        if (accordionButton) {
          accordionButton.click();
        }
      }
    };
  } else {
    // Si l'URL ne contient pas d'ancre, simplement rediriger vers l'URL fournie
    window.location.href = url;
  }
}


